import React, { useState, useEffect } from 'react';
import { BrowserRouter, Switch, Route, Redirect } from 'react-router-dom';
import { message } from 'antd';
import axios from 'axios';
import Login from './pages/Login';
import Chat from './pages/Chat';

function App() {
  const [authenticated, setAuthenticated] = useState(null);

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    try {
      const params = new URLSearchParams(window.location.search);
      const token = params.get('token');

      if (token) {
        await axios.post('/api/chat/auth/token', { token }, { withCredentials: true });
        params.delete('token');
        const query = params.toString();
        const nextUrl = `${window.location.pathname}${query ? `?${query}` : ''}${window.location.hash}`;
        window.history.replaceState({}, document.title, nextUrl);
      }

      const response = await axios.get('/api/chat/auth/status', { withCredentials: true });
      setAuthenticated(response.data.authenticated === true);
    } catch (err) {
      if (new URLSearchParams(window.location.search).get('token')) {
        message.error('Invalid or expired token');
      }
      setAuthenticated(false);
    }
  };

  if (authenticated === null) {
    return <div className="app-loading">Loading...</div>;
  }

  return (
    <BrowserRouter basename="/ai-chat">
      <Switch>
        <Route path="/login">
          {!authenticated ? <Login onLogin={() => setAuthenticated(true)} /> : <Redirect to="/chat" />}
        </Route>
        <Route path="/chat">
          {authenticated ? <Chat /> : <Redirect to="/login" />}
        </Route>
        <Route path="/">
          <Redirect to={authenticated ? '/chat' : '/login'} />
        </Route>
      </Switch>
    </BrowserRouter>
  );
}

export default App;
